module.exports = __webpack_public_path__ + "img/Vendor.21de9a96.svg";